module.exports = __webpack_public_path__ + "img/thedoctor.1448712e.png";